import { useRef, useState } from 'react';
import { notifications } from '@mantine/notifications';
import type { AttendanceActionType, AttendanceActionView } from 'shared-models/browser';
import { attendanceService } from '../../../services/attendance/attendance.service';
import { toHebrewApiErrorMessage } from '../../../services/index/index.service';

export function useAttendanceClockAction({ tenantId, setError, onRecorded }: {
  tenantId: string;
  setError: (message: string | null) => void;
  onRecorded: (action: AttendanceActionView) => void;
}) {
  const inFlightRef = useRef(false);
  const [isAttendanceActioning, setIsAttendanceActioning] = useState(false);
  const [isEmployeeReportWarningOpen, setEmployeeReportWarningOpen] = useState(false);

  const handleAttendanceActionFromGate = async (employeeId: number, pin: string, actionType: AttendanceActionType): Promise<boolean> => {
    if (inFlightRef.current) return false;
    inFlightRef.current = true;
    setIsAttendanceActioning(true);
    setError(null);
    try {
      const action = await attendanceService.clockAction(tenantId, { employeeId, pin, actionType });
      onRecorded(action);
      notifications.show({ color: 'green', title: 'נוכחות',
        message: actionType === 'clock_in' ? 'הכניסה נשמרה בהצלחה' : 'היציאה נשמרה בהצלחה', autoClose: 3000 });
      return true;
    } catch (error: unknown) {
      if (error instanceof Error && error.message === 'EMPLOYEE_REPORT_REQUIRED') {
        setEmployeeReportWarningOpen(true);
      } else {
        setError(error instanceof Error ? toHebrewApiErrorMessage(error.message) : 'אירעה שגיאה. נסו שוב.');
      }
      return false;
    } finally {
      inFlightRef.current = false;
      setIsAttendanceActioning(false);
    }
  };

  return { isAttendanceActioning, isEmployeeReportWarningOpen,
    showEmployeeReportWarning: () => setEmployeeReportWarningOpen(true),
    dismissEmployeeReportWarning: () => setEmployeeReportWarningOpen(false), handleAttendanceActionFromGate };
}